import type { GetError500Response } from './types';

import { getGenericEndpoint } from './get.api';

export const getError500 = async (lang?: string) => {
    return await getGenericEndpoint<GetError500Response>('errors/500', lang);
};
